import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosPost from '../helpers/axios-helper';
import '../styles/VenueFeatureCards.css';

/**
 * The review, interview and menu attached to a venue, as a row of cards on
 * that venue's own page.
 *
 * Three abreast when all three exist, and the row simply narrows when fewer
 * do, so one card does not stretch across the column looking like a banner.
 * The server returns only what is published and has substance, so nothing here
 * can be a dead link.
 */

const KINDS = {
  review:    { eyebrow: 'Our review',  cta: 'Read our review' },
  interview: { eyebrow: 'Interview',   cta: 'Read the interview' },
  menu:      { eyebrow: 'Menu',        cta: 'See the menu' },
};

const ORDER = ['review', 'interview', 'menu'];

export default function VenueFeatureCards({ itemType, itemId, venuePath, venueTitle }) {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    if (!itemId || !itemType) return undefined;
    const controller = new AbortController();
    axiosPost(
      'features/for-item',
      { 'Content-Type': 'application/json' },
      { item_type: itemType, item_id: itemId },
      (resp) => {
        if (resp?.success) setFeatures(resp.data.features || []);
      },
      controller
    );
    return () => controller.abort();
  }, [itemType, itemId]);

  if (features.length === 0) return null;

  const ordered = ORDER
    .map(kind => features.find(f => f.kind === kind))
    .filter(Boolean);

  return (
    <div className={`vfc-row vfc-count-${ordered.length}`}>
      {ordered.map((feature) => {
        const spec = KINDS[feature.kind] || KINDS.review;
        return (
          <Link
            key={feature.kind}
            to={`${venuePath}/${feature.kind}`}
            className='vfc-card'
          >
            <p className='vfc-eyebrow'>{spec.eyebrow}</p>
            <h2 className='vfc-title'>
              {feature.title || `${spec.eyebrow} of ${venueTitle}`}
            </h2>
            {feature.standfirst && (
              <p className='vfc-text'>{feature.standfirst}</p>
            )}
            <span className='vfc-link'>{spec.cta}</span>
          </Link>
        );
      })}
    </div>
  );
}
